import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Sitemap } from '../components/Sitemap';
import { LearningPathCard } from '../components/LearningPathCard';
import { ProgressStats } from '../components/ProgressStats';
import { useLearningData } from '../context/LearningDataContext';
import { BookOpenIcon, BookmarkIcon, FilterIcon, GridIcon, ListIcon } from 'lucide-react';
export function LearningPathPage() {
  const {
    isArabic
  } = useLanguage();
  const {
    learningData
  } = useLearningData();
  // Add loading state check
  if (!learningData || !Array.isArray(learningData) || learningData.length === 0) {
    return <div className="w-full px-6 md:px-10 lg:px-20 py-16" data-id="element-3079">
        <div className="max-w-4xl mx-auto text-center" data-id="element-3080">
          <div className="w-12 h-12 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto mb-4" data-id="element-3081"></div>
          <p className="text-gray-600 dark:text-gray-300" data-id="element-3082">
            {isArabic ? 'جارِ تحميل البيانات...' : 'Loading data...'}
          </p>
        </div>
      </div>;
  }
  return <div className="w-full px-6 md:px-10 lg:px-20 py-16" data-id="element-3083">
      <Sitemap currentPage={{
      en: 'Learning Path',
      ar: 'مسار التعلم'
    }} breadcrumbs={[{
      label: {
        en: 'Learn',
        ar: 'تعلم'
      },
      href: '/learn'
    }]} data-id="element-3084" />
      <div className="max-w-4xl mx-auto" data-id="element-3085">
        <div className="text-center mb-12" data-id="element-3086">
          <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-4" data-id="element-3087">
            {isArabic ? 'مسار التعلم الشخصي' : 'Personal Learning Path'}
          </h1>
          <p className="text-xl text-gray-600 dark:text-gray-300" data-id="element-3088">
            {isArabic ? 'تتبع تقدمك وتعلم بخطوتك الخاصة' : 'Track your progress and learn at your own pace'}
          </p>
        </div>
        <div className="mb-12" data-id="element-3089">
          <ProgressStats progress={25} data-id="element-3090" />
        </div>
        <div className="space-y-8" data-id="element-3091">
          {learningData.map(course => <div key={course.id} className="space-y-6" data-id="element-3092">
              <div className="flex items-center gap-3" data-id="element-3093">
                <BookOpenIcon className="w-6 h-6 text-blue-600 dark:text-blue-400" data-id="element-3094" />
                <h2 className="text-2xl font-semibold text-gray-900 dark:text-white" data-id="element-3095">
                  {isArabic ? course.title.ar : course.title.en}
                </h2>
              </div>
              <div className="space-y-6" data-id="element-3096">
                {course.units && Array.isArray(course.units) && course.units.map(unit => <LearningPathCard key={unit.id} unit={{
              id: unit.id,
              title: unit.title,
              description: unit.description,
              lessonsCount: unit.lessons ? unit.lessons.length : 0,
              progress: unit.progress,
              isCompleted: unit.progress === 100,
              isLocked: unit.isLocked,
              difficulty: unit.difficulty,
              category: unit.category,
              estimatedTime: isArabic ? unit.estimatedTimeAr : unit.estimatedTime
            }} data-id="element-3097" />)}
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}